import { API } from '../../api';
import { DimaContext } from '../../DimaContext';
import { PageHeader, Row, Spin, notification } from 'antd';
import { useParams } from 'react-router-dom';
import FieldsTable from './fieldsTable';
import React, { useContext, useEffect, useState } from 'react';

const ActionType = () => {
  const context = useContext(DimaContext);
  const { name } = useParams();
  const [actionType, setActionType] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchActionTypeByName = async () => {
    setLoading(true);

    try {
      const { data } = await API.get(`/dis/actionTypes/${name}?clientId=${context.client.id}`);
      setActionType(data);
    } catch (err) {
      notification.error({
        message: 'Error',
        description: 'Failed to get Action Type',
        duration: 3,
        placement: 'topLeft',
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchActionTypeByName();
  }, [name]);

  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => window.history.back()}
        title="Action Type Detail"
      />
      <Spin spinning={loading}>
        <Row>
          <p>
            <span style={{ fontWeight: 'bold' }}>Name: </span>
            {actionType?.name}
          </p>
        </Row>
        <div style={{ color: 'black', fontSize: '14px', fontWeight: 'bold' }}>Input Fields</div>
        {actionType?.inputFields && <FieldsTable fields={actionType.inputFields} />}
        <div style={{ color: 'black', fontSize: '14px', fontWeight: 'bold', marginTop: '20px' }}>
          Output Fields
        </div>
        {actionType?.outputFields && (
          <FieldsTable fields={actionType.outputFields} loading={loading} />
        )}
      </Spin>
    </>
  );
};

export default ActionType;
